import { CustomizedButton, CustomizedDropdownMenu, CustomizedTooltip } from 'components/common/index';
import Icon from 'components/common/Icons/icon';
import { Link } from 'react-router-dom';
import classes from 'components/common/ProgramLibraryDropdownMenu/dropdownMenu.module.scss';
import { ModalManger } from 'components/common/ProgramLibraryDropdownMenu/components/ModalManger/ModalManager';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import useUserHook from 'hooks/useUserHook';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import { IContract, IProject, useProjectTreeStore } from 'store/projectContract.store';
import { useQueryGetGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList-2.query';
import { findeNodeByUUID } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const DropdownMenu = ({
    callback,
}: {
    callback?: (project: IProject | null, contract: IContract | null) => void;
}) => {
    const { project, contract, update } = useProjectTreeStore();
    const { ability } = useUserHook();

    const isAdmin = ability.can('all', 'Admin');

    const { data } = useQueryGetGeneralHierarchyList();
    const handleAddSubProject = () => {
        if (data) {
            const parent = data && project ? findeNodeByUUID(data, project.uuid) : null;
            update({ parentNode: parent });
        }
        update({ modalType: 'subProgram' });
    };

    return (
        <div className={classes.container}>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Manage Library`}
                        triggerElement={
                            <CustomizedButton
                                data-testid={'manage-library'}
                                endIcon={<Icon name={'header-arrow-down'} size="1.5rem" color={'#2C8FA5'} />}
                                startIcon={
                                    <MuiIcon icon={'folder'} type={'outlined'} fontSize="1.5rem" color={'#2C8FA5'} />
                                }
                                color={'secondary'}
                            >
                                Manage Library
                            </CustomizedButton>
                        }
                    />
                }
                menuStyles={{
                    maxHeight: 'initial',
                }}
            >
                <div onClick={() => update({ modalType: 'project' })}>Add Project</div>
                <div onClick={handleAddSubProject}>Add Sub Program</div>

                {contract && <div onClick={() => update({ modalType: 'RENAME_SUB_PROGRAM' })}>Rename Sub-Program</div>}
                <div onClick={() => update({ modalType: 'RENAME_PROJECT' })}>Rename Project</div>
                {contract && <div onClick={() => update({ modalType: 'DELETE_SUB_PROGRAM' })}>Delete Sub-Program</div>}
                <div onClick={() => update({ modalType: 'DELETE_PROJECT' })}>Delete Project</div>
                {contract && isAdmin && (
                    <div onClick={() => update({ modalType: 'REFRESH_SUB_PROGRAM' })}>Refresh Sub-Program</div>
                )}
                {isAdmin && <div onClick={() => update({ modalType: 'REFRESH_PROJECT' })}>Refresh Project</div>}
                {contract && (
                    <Link
                        className={classes.programLibraryMenuLink}
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PROJECT_PATH,
                            projectConfig.programLibrary.link,
                            projectConfig.subProgramPreferences.link,
                        )}
                    >
                        Sub-Program Preferences
                    </Link>
                )}
                <Link
                    className={classes.programLibraryMenuLink}
                    to={AppRoutes.buildPath(
                        AppRoutes.DASHBOARD_PROJECT_PATH,
                        projectConfig.programLibrary.link,
                        projectConfig.projectPreferences.link,
                    )}
                >
                    Project Preferences
                </Link>
            </CustomizedDropdownMenu>

            <ModalManger callback={callback} />
        </div>
    );
};
